import { SMS_CODE_STATUSES } from './ContractSignSlice'


export enum verificationCodeInputsNames {
   VERIFICATION_CODE_INPUT_1 = "VERIFICATION_CODE_INPUT_1",
   VERIFICATION_CODE_INPUT_2 = "VERIFICATION_CODE_INPUT_2",
   VERIFICATION_CODE_INPUT_3 = "VERIFICATION_CODE_INPUT_3",
   VERIFICATION_CODE_INPUT_4 = "VERIFICATION_CODE_INPUT_4",
   VERIFICATION_CODE_INPUT_5 = "VERIFICATION_CODE_INPUT_5",
   VERIFICATION_CODE_INPUT_6 = "VERIFICATION_CODE_INPUT_6",
}

export type TVerificationCodeInputsNamesModel = keyof typeof verificationCodeInputsNames

export interface IContractSignState {
   verificationCodeInputs: {
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_1]: string;
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_2]: string;
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_3]: string;
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_4]: string;
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_5]: string;
      [verificationCodeInputsNames.VERIFICATION_CODE_INPUT_6]: string;
   }
   sendCodeSmsStatus: {
      isLimit : boolean;
      hasError: boolean;
      sendedSmsCount: number;
   }
   
   currentFullSmsCode: string | null;
   agreemenFileName: string;
   currentSmsCodeTextState: SMS_CODE_STATUSES | null;
   currentClientPeselReservedErrorText: string | null;
}

export interface ISetVerificationCodeInputValueAction {
   inputName: TVerificationCodeInputsNamesModel;
   newValue: string;
}